import React, {useContext, useState} from 'react';
import {Container, Row, Col, Card, Button, Table, ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import { Context } from "../../index";
import UserPaySubscriptionFull from "../../components/payment/UserPaySubscriptionFull";
import {REGISTRATION_ROUTE} from "../../utils/consts";
import {useNavigate} from "react-router-dom";

const Pay = () => {
const { user } = useContext(Context);
    const navigate = useNavigate();
    const [selectedPrice, setSelectedPrice] = useState(null); // ✅ Храним выбранный тариф
    const [billingCycle, setBillingCycle] = useState("monthly"); // ✅ "monthly" или "yearly"
    // Список тарифов с их ценами
    const plans = [
        {
            name: "FREE",
            monthlyPriceId: "",
            yearlyPriceId: "",
            Book_Limit: "Only One Book",
            Assign_Limit: "Two at a Time",
            Track_Review: "Full Access",
            Library: "Limited Access",
            Library_Filter: "Limited Access",
            Photo_Review: "Limited Access",
            Search_Buy: "Limited Access",
            ReviewerCS: "+200 Virts Extra",
            Trust_Score: "+100 on Signup",
            Support: "Full Access",
            monthlyPrice: "$0.00 Mo",
            yearlyPrice: "$0.00 Yr",
            logo: "./logo/virtalibry_dark_free_no_bg.png"
        },
        {
            name: "ESSENTIAL",
            monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_ESSENTIAL_MONTHLY,
            yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_ESSENTIAL_EARLY,
            Book_Limit: "Up to 5 Books",
            Assign_Limit: "Three at a Time",
            Track_Review: "Full Access",
            Library: "Full Access",
            Library_Filter: "Full Access",
            Photo_Review: "Full Access",
            Search_Buy: "Full Access",
            ReviewerCS: "+100 Virts Extra",
            Trust_Score: "+300 when Buy",
            Support: "Full Access",
            monthlyPrice: "$9.99 Mo",
            yearlyPrice: "$99.99 Yr",
            logo: "./logo/virtalibry_dark_es_no_bg.png"
        },
        {
            name: "PREMIUM",
            monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_MONTHLY,
            yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_EARLY,
            Book_Limit: "Up to 50 Books",
            Assign_Limit: "Five at a Time",
            Track_Review: "Full Access",
            Library: "Full Access",
            Library_Filter: "Full Access",
            Photo_Review: "Full Access",
            Search_Buy: "Full Access",
            ReviewerCS: "Free Usage",
            Trust_Score: "+500 when Buy",
            Support: "Full Access",
            monthlyPrice: "$19.99 Mo",
            yearlyPrice: "$199.99 Yr",
            logo: "./logo/virtalibry_dark_pr_no_bg.png"
        },
        {
            name: "MAXIMUM",
            monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_MAXIMUM_MONTHLY,
            yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_MAXIMUM_EARLY,
            Book_Limit: "Up to 500 Books",
            Assign_Limit: "Ten at a Time",
            Track_Review: "Full Access",
            Library: "Full Access",
            Library_Filter: "Full Access",
            Photo_Review: "Full Access",
            Search_Buy: "Full Access",
            ReviewerCS: "Free Usage",
            Trust_Score: "+1000 when Buy",
            Support: "Full Access",
            monthlyPrice: "$29.99 Mo",
            yearlyPrice: "$299.99 Yr",
            logo: "./logo/virtalibry_dark_max_no_bg.png"
          //  pc: "93IE2xF0",
        }
    ];


    return (

        <Row className="justify-content-center mt-2 mx-0">
                {selectedPrice ? null : (
                    <Col xs={12} className="text-center mb-4">
                        <ToggleButtonGroup type="radio"  size="sm" name="billingCycle" value={billingCycle} onChange={setBillingCycle}>
                            <ToggleButton
                                id="monthly"
                                variant={billingCycle === "monthly" ? "success" : "outline-success"}
                                value="monthly"
                            >
                                Monthly
                            </ToggleButton>
                            <ToggleButton
                                id="yearly"
                                variant={billingCycle === "yearly" ? "success" : "outline-success"}
                                value="yearly"
                            >
                                Yearly (Save 20%)
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                )}

                {selectedPrice ? (
                    <UserPaySubscriptionFull priceId={selectedPrice} />
                ) : (
                    <Container style={{ maxWidth: "1200px" }} className="">
                        <Row className="justify-content-center">
                            {plans.map((plan) => (
                                <Col key={plan.name} xs={12} sm={6} md={4} lg={3} xl={3} className="mb-4 d-flex justify-content-center">
                                    <Card
                                        className={`shadow-sm border-secondary ${user.user.tariff_plan === plan.name ? "shadow-lg" : ""}`}
                                        style={{
                                            borderRadius: "6px",
                                            transition: "transform 0.2s, box-shadow 0.2s",
                                            cursor: "pointer",
                                            width: "100%",
                                            maxWidth: "300px",
                                            boxShadow: user.user.tariff_plan === plan.name
                                                ? "0px 6px 16px rgba(0, 0, 0, 0.2)"
                                                : "0px 4px 12px rgba(0, 0, 0, 0.1)",
                                            transform: user.user.tariff_plan === plan.name ? "translateY(-5px)" : "translateY(0)",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.boxShadow = "0px 6px 16px rgba(0, 0, 0, 0.2)";
                                            e.currentTarget.style.transform = "translateY(-5px)";
                                        }}
                                        onMouseLeave={(e) => {
                                            if (user.user.tariff_plan !== plan.name) {
                                                e.currentTarget.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.1)";
                                                e.currentTarget.style.transform = "translateY(0)";
                                            }
                                        }}
                                    >
                                        <Card.Body className="d-flex flex-column align-items-center text-center">
                                            <img
                                                src={plan.logo}
                                                alt="Virtalibry Logo"
                                                className="img-fluid mx-auto mb-3"
                                                style={{ maxWidth: "150px", height: "auto" }}
                                            />
                                            <h5 className="fw-bold text-success">
                                                {plan.name} <span className="text-muted fst-italic">{billingCycle === "monthly" ? plan.monthlyPrice : plan.yearlyPrice}</span>
                                            </h5>
                                            <Table striped bordered size="sm" className="table-fixed text-muted small">
                                                <tbody>
                                                {[
                                                    ["Book Limit", plan.Book_Limit],
                                                    ["Activity Limit", plan.Assign_Limit],
                                                    ["Tracking Tools", plan.Track_Review],
                                                    ["Library Access", plan.Library],
                                                    ["Library Filters", plan.Library_Filter],
                                                    ["Visual Content", plan.Photo_Review],
                                                    ["Discovery Mode", plan.Search_Buy],
                                                    ["Regional Targeting", plan.ReviewerCS],
                                                    ["Account Score", plan.Trust_Score],
                                                    ["Support", plan.Support]
                                                ].map(([key, value], idx) => (
                                                    <tr key={idx}>
                                                        <td className="text-start">{key}:</td>
                                                        <td className="text-start">{value}</td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </Table>
                                            <Button
                                                variant="success"
                                                className="mt-2 btn btn-sm"
                                                disabled={!user?.user?.id ? false : user.user.tariff_plan === plan.name || (plan.name === "FREE" && user.user.tariff_plan !== "FREE")}
                                                onClick={() => {
                                                    if (!user?.user?.id) {
                                                        navigate(REGISTRATION_ROUTE);
                                                    } else {
                                                        setSelectedPrice(billingCycle === "monthly" ? plan.monthlyPriceId : plan.yearlyPriceId);
                                                    }
                                                }}
                                            >
                                                {!user?.user?.id
                                                    ? 'Join Virtalibry Now'
                                                    : user.user.tariff_plan === plan.name
                                                        ? "Your current plan"
                                                        : plan.name === "FREE" && user.user.tariff_plan !== "FREE"
                                                            ? "Unavailable"
                                                            : "Subscribe"
                                                }
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                )}
            </Row>

    );
};

export default Pay;